/* src/app/features/honra/stoploss/stoploss-pesquisa/stoploss-pesquisa.component.css */
.moeda {
  text-align: right;
}
.titulo-moeda {
  text-align: right;
}
.letra-miuda {
  font-size: 12px;
  font-style: italic;
}
.texto-destaque {
  font-weight: bolder;
}
.fundo-destaque {
  background-color: lightyellow;
}
/*# sourceMappingURL=stoploss-pesquisa.component.css.map */
